// How much one chat message can carry. The communication service refuses a
// form with more than MAX_ATTACHMENTS files, so the two are changed together.

export const MAX_ATTACHMENTS = 10;
export const MAX_ATTACHMENTS_BYTES = 100 * 1024 * 1024;

const totalBytes = (files: File[]) => files.reduce((sum, file) => sum + file.size, 0);

/**
 * Takes the picked files, in order, while both limits still hold against what
 * is already staged. A file that does not fit is left out and the rest are
 * still tried, so a large file does not keep out the small ones after it.
 * `refusals` holds one line per limit that was hit, ready for a toast.
 */
export const admitAttachments = (staged: File[], picked: File[]) => {
  let count = staged.length;
  let bytes = totalBytes(staged);
  const accepted: File[] = [];
  const refusals = new Set<string>();

  for (const file of picked) {
    if (count >= MAX_ATTACHMENTS) {
      refusals.add(`You can attach up to ${MAX_ATTACHMENTS} files to one message`);
      continue;
    }

    if (bytes + file.size > MAX_ATTACHMENTS_BYTES) {
      refusals.add(
        `Couldn't attach ${file.name} — files in one message can add up to ${MAX_ATTACHMENTS_BYTES / 1024 / 1024} MB`,
      );
      continue;
    }

    accepted.push(file);
    count += 1;
    bytes += file.size;
  }

  return { accepted, refusals: [...refusals] };
};
